import { useEffect, useRef } from "react";
import { api } from "@/lib/api";

/**
 * VoiceAnnouncementsPoller — invisible component that polls
 * /api/trading/voice_announcements every 15s and speaks any pending
 * announcements through the supplied speak() callback. Used by the
 * auto-trader to actually voice "Sir, auto-trader just placed a £50 BUY
 * on NVDA…" when a trade fires.
 *
 * Pass jarvis.speak from useJarvis as the `speak` prop.
 */
export default function VoiceAnnouncementsPoller({ speak }) {
  const speakRef = useRef(speak);
  speakRef.current = speak;

  useEffect(() => {
    let stopped = false;
    let inFlight = false;
    const poll = async () => {
      if (stopped || inFlight || document.hidden) return;
      inFlight = true;
      try {
        const r = await api.get("/trading/voice_announcements");
        const items = r.data?.announcements || [];
        for (const a of items) {
          try { await speakRef.current?.(a.text); } catch (_) { /* ignore TTS errors */ }
        }
      } catch (_) { /* ignore */ }
      finally { inFlight = false; }
    };
    const id = setInterval(poll, 15000);
    // initial fire after 10s so we don't compete with boot greeting
    const initTimer = setTimeout(poll, 10000);
    return () => { stopped = true; clearInterval(id); clearTimeout(initTimer); };
  }, []);

  return null;
}
